import { DO_NOT_USE_FaWrapper } from '../../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { jsxs, jsx } from 'react/jsx-runtime';
import { IconButton } from '../../../buttons/IconButton/IconButton.js';
import VisuallyHidden from '../../../../../visually-hidden/VisuallyHidden.js';

function ScrollButton(props) {
  var _jsx2, _jsx3;
  var direction = props.direction,
    label = props.label,
    onClick = props.onClick;
  return /*#__PURE__*/jsxs(IconButton, {
    appearance: "ghost",
    size: "small",
    onClick: onClick,
    children: [direction === 'left' ? /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
      icon: "chevron-left"
    }, _jsx2["icon"] = faChevronLeft, _jsx2)) : /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx3 = {
      icon: "chevron-right"
    }, _jsx3["icon"] = faChevronRight, _jsx3)), /*#__PURE__*/jsx(VisuallyHidden, {
      children: label
    })]
  });
}

export { ScrollButton };
